export enum LoginFormField {
  email = 'email',
  password = 'password',
}

export type LoginFormValues = {
  [LoginFormField.email]: string;
  [LoginFormField.password]: string;
};
